import { selectCompEditState } from 'projectRedux/store';
import { eppTerminalTypeAdapter } from 'application/components/redux/adapters/eppTerminalTypeAdapter';

export const {
  selectAll: selectAllEppTerminalTypeEdit,
  selectById: selectEppTerminalTypeEditById,
  selectEntities: selectEppTerminalTypeEditEntities,
} = eppTerminalTypeAdapter.getSelectors((state) => selectCompEditState(state).eppTerminalTypes);
